import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setBrandingClientGroup } from './branding-client-group.actions';
export const brandingClientGroupId = createReducer(null, on(setBrandingClientGroup, (state, action) => {
    return action.brandingClientGroupId;
}), on(resetAllCustomPdfReportItems, () => {
    return null;
}));
